module.exports = __webpack_public_path__ + "static/img/production1.d5a6855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/production1.png
// module id = TdCn
// module chunks = 2